import React from "react";
import {
  CButton,
  CListGroupItem,
  CListGroup,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CModalTitle,
} from "@coreui/react";

import { symptoms as data } from "./symptoms";

function Symptoms({ show, onClose }) {
  return (
    <CModal show={show} onClose={onClose}>
      <CModalHeader>
        <CModalTitle>Síntomas de COVID-19</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CListGroup accent>
          {data.map((symptom) => (
            <CListGroupItem key={symptom} accent="secondary">
              {symptom}
            </CListGroupItem>
          ))}
        </CListGroup>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Cerrar
        </CButton>
      </CModalFooter>
    </CModal>
  );
}

export default Symptoms;
